// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2UJ-7","question":"Question_question__1-XKM","description":"Question_description__294lq"};